module.exports = __webpack_public_path__ + "img/bedrijven.c59f5876.png";